import {
	CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE,
	REFRESH_EDITOR_CONTENT_EXPERIENCE,
} from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { collectAll } from '@confluence/experience-tracker/entry-points/ExperienceEventCollector.ts';

export const collectCreateContentExperiences = (events, experience) => {
	collectAll([CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE])(events, experience);
};

export const collectUpdateContentExperiences = (events, experience) => {
	collectAll([CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE, REFRESH_EDITOR_CONTENT_EXPERIENCE])(
		events,
		experience,
	);
};
